<template>
  <ul class="socials-list">
    <li
      v-for="link in links"
      :key="link.id"
    >
      <BurgerSocialLink
        :link="link"
        @click-menu-item="$emit('click-menu-item', { link, event: 'Социальная активность' })"
      />
    </li>
  </ul>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import BurgerSocialLink from '~/components/TheHeader/Burger/BurgerSocialLink.vue';
  import type { ILink } from '~/components/ArrowMenu/ArrowMenu';

  export default defineNuxtComponent({
    name: 'BurgerSocialsList',
    components: {
      BurgerSocialLink,
    },

    props: {
      links: {
        type: Array as PropType<ILink[]>,
        required: true,
      },
    },

    emits: ['click-menu-item'],
  });
</script>

<style lang="scss" scoped>
  .socials-list {
    max-width: 250px;
    padding-left: $spacing-8;
    @include big-tablet {
      width: 200px;
      padding: 0 $spacing-3;
    }
    display: flex;
    flex-wrap: wrap;
  }
</style>
